<template>
  <div v-loading="loading">
    <div class="table-area">
      <el-table :data="templateFile" border style="width: 100%" :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }">
        <el-table-column label="序号" type="index" width="50">
        </el-table-column>
        <el-table-column label="是否上传" width="60">
          <template slot="header">
            是否上传
            <el-checkbox @change="changeAllUpLoad()" v-model="allUpLoad"></el-checkbox>
          </template>
          <template slot-scope="scope">
            <el-checkbox @change="changeCheckBox(scope)" v-model="scope.row.isUpload"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="原附件删除" width="60">
          <template slot="header">
            原附件删除
            <el-checkbox @change="changeAllDelete()" v-model="allDelete"></el-checkbox>
          </template>
          <template slot-scope="scope">
            <el-checkbox @change="changeCheckBox(scope)" v-model="scope.row.isDelete"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column prop="itemNumber" sortable label="内部编码" width="150">
        </el-table-column>
        <el-table-column prop="customNumber" sortable label="客户编码" width="150">
        </el-table-column>
        <el-table-column prop="fileName" label="匹配附件">
          <template slot-scope="scope">
            <el-tag class="fileNameTag" size="mini" closable @close="removeFileName(item, scope.row.fileList)"
              v-for="(item, index) in scope.row.fileList" :key="index">{{ item }}</el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="RelatedDoc" label="关联文档"> </el-table-column> -->
      </el-table>
      <!-- <el-button @click="beforeUpLoad">test</el-button> -->
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import BottomTips from '@/components/bottomTips.vue'
import { CHANGE_FOR_MEDLINKET } from '@/utils/constants.js'

export default {
  data() {
    return {
      loading: false,
      upLoadProgress: 0,
      upLoadDialog: false, //上传
      fileList: [],
      changeInfo: {},
      templateFile: [],
      allUpLoad: true,
      allDelete: true,
    }
  },
  props: {
    matchAttach: Array,
  },

  components: { BottomTips },
  created() {
    console.log('处理前', this.matchAttach)
    this.templateFile = this.matchAttach
    this.templateFile.forEach((item) => {
      item.fileList = item.fileName.split('|').filter((item) => item !== '')
    })
    console.log('处理后', this.templateFile)
    // this.getChangeInfo()
    // this.templateFile = this.matchAttach
    // console.log('这个数据是1', this.templateFile)
    // console.log('这个数据是2', this.matchAttach)
  },
  mounted() {
    this.getChangeInfo()
    // this.setDrag();
    // const dropzone = document.querySelector('.dovDropzone')
    // dropzone.addEventListener('dragover', (event) => {
    //   event.target.classList.add('fileshover')
    //   event.preventDefault() //阻止默认行为，允许放置
    // })
    // dropzone.addEventListener('drop', (event) => {
    //   const dataTransferItemList = event.dataTransfer.items
    //   for (const dataTransferItem of dataTransferItemList) {
    //     const file = dataTransferItem.webkitGetAsEntry()
    //     this.handlefile(file)
    //   }
    //   event.preventDefault() //阻止浏览器默认行为，不会自动打开文件管理页面
    // })
  },
  methods: {
    changeAllUpLoad() {
      const newVal = this.allUpLoad
      console.log('点击全部上传', newVal)
      this.templateFile.forEach((item) => {
        item.isUpload = newVal
      })
      // this.allUpLoad = newVal
    },
    changeAllDelete() {
      const newVal = this.allDelete
      console.log('点击全部上传', newVal)
      this.templateFile.forEach((item) => {
        item.isDelete = newVal
      })
      // this.allDelete = newVal
    },

    changeCheckBox(scope) {
      console.log('这是scope', scope, this.matchAttach)
      this.$forceUpdate()
    },
    tempFileName(nameStr) {
      console.log('tag的数据是', nameStr)
      return nameStr.split('|')
    },
    removeFileName(item, list) {
      console.log('删除操作', item, list)
      const index = list.indexOf(item)
      if (index !== -1) {
        list.splice(index, 1)
      }
      if (list.length == 0) {
        this.templateFile.forEach((obj) => {
          if (obj.fileList.length != 0) {
            ; (obj.isDelete = true), (obj.isUpload = true)
          } else {
            ; (obj.isDelete = false), (obj.isUpload = false)
          }
        })
      }
      this.$forceUpdate()
    },
    // submitFileName() {
    //   console.log('点击提交', this.itemData)
    //   const fileNameList = this.templateFile.map((i) => i.matchAttach)
    //   if (!fileNameList.length) {
    //     alert('当前文件夹为空')
    //     return
    //   }
    //   const result = {
    //     ...this.itemData,
    //     fileNameList,
    //   }
    //   console.log('组装结果是', result)
    //   axios.post('/pmdm/custom/getAIFileMapping', result).then((res) => {
    //     console.log('提交的结果是', res)
    //   })
    // },
    deleteFile(item) {
      this.fileList = this.fileList.filter((i) => i.order !== item.order)
    },
    // done() {
    //   this.loading = true
    //   this.setChangeRelease()
    //     .then((res) => {
    //       const { object } = res.data
    //       return this.setSaveTable(object)
    //     })
    //     .then((res) => {
    //       this.fileList.map((i) => {
    //         this.upLoad(i)
    //       })
    //     })
    //     .finally((_) => {
    //       this.loading = false
    //     })
    // },
    cancel() {
      this.$emit('dialogClose')
    },
    setChangeRelease() {
      const obj = { ...CHANGE_FOR_MEDLINKET }
      return axios.post(`/pmdm/changes/saveChangeP1P2P3`, obj)
    },
    setSaveTable(object) {
      const { id, classId, subclassId: subClassId } = object
      this.changeInfo = {
        changeId: id,
        changeClassId: classId,
        changeSubClassId: subClassId,
      }
      const obj = {
        tableId: 5,
        changeObjId: {
          id,
          classId,
          subClassId,
          version: this.version,
        },
        insertAffectedItem: [
          { changeId: id, item: this.$store.state.objectId.id, 1005007: 248 },
        ],
        inheritAttachment: false,
      }
      return axios.post('/pmdm/changes/saveTable', obj)
    },
    handlefile(file) {
      let num = 1
      if (file.isFile) {
        // 是文件执行上传操作
        //file.file() 方法用于读取文件内容
        file.file((f) => {
          f.order = num + f.lastModified
          this.fileList.push(f)
          num++
          return
        })
      } else {
        const dirReader = file.createReader()
        dirReader.readEntries((entries) => {
          for (let i = 0; i < entries.length; i++) {
            this.handlefile(entries[i])
          }
        })
      }
    },
    // handleFileSelect(event) {
    //   const { files } = event.target
    //   let num = 1
    //   for (const key in files) {
    //     if (Object.prototype.hasOwnProperty.call(files, key)) {
    //       const element = files[key]
    //       element.order = num + element.lastModified
    //       this.fileList.push(files[key])
    //       num++
    //     }
    //   }
    //   console.log('当前的文件list是', this.fileList)
    //   this.fileList.forEach((obj) => {
    //     let targetObj = {
    //       matchAttach: obj.name,
    //       isDelete: true,
    //       isUpload: true,
    //       InternalNum: '暂无',
    //       ExternalNum: '暂无',
    //       RelatedDoc: '暂无',
    //     }
    //     this.templateFile.push(targetObj)
    //   })
    // },

    handleClose(done) {
      this.$confirm(this.$t('message.tips.closeUpLoad'))
        .then((_) => {
          this.upLoadDialog = false
        })
        .catch((_) => { })
    },

    changeIsUpload(data) {
      console.log('是否上传1', data, data.row)
    },
    getHashQueryParams() {
      const hash = window.location.hash // 获取 # 后的内容
      const queryIndex = hash.indexOf('?')
      const result = {}
      if (queryIndex !== -1) {
        const queryString = hash.substring(queryIndex + 1)
        const params = new URLSearchParams(queryString)
        for (const [key, value] of params.entries()) {
          result[key] = value
        }
      }
      console.log('参数结果是', result)
      return result
    },
    // beforeUpLoad(files) {
    //   console.log('上传前的文件有', files)
    //   const urlParam = this.getHashQueryParams()
    //   this.templateFile.forEach((temp) => {
    //     console.log('遍历表格数据中', temp)
    //     if (temp.isDelete) {
    //       console.log('删除原附件中')
    //       const param = {
    //         itemId: Number(temp.itemId),
    //         itemSubClass: Number(temp.itemSubclassId),
    //         changeId: Number(urlParam.id),
    //         changeSubClass: Number(urlParam.subClassId),
    //       }
    //       console.log('删除请求的参数是', param)
    //       axios
    //         .get(`/pmdm/changes/deleteAIFile${this.params(param)}`)
    //         .then((res) => {
    //           console.log('删除结果', res)
    //           if (res.data.code == 200) {
    //             if (temp.isUpload) {
    //               console.log('上传新附件中')
    //               temp.fileList.forEach((fileObj) => {
    //                 let single = files.filter((file) => file.name == fileObj)
    //                 console.log('文件', single)
    //                 this.upLoad(single[0], temp)
    //               })
    //             }
    //           }
    //           //我希望这里上传成功后直接执行this.templateFile.forEach的下一个temp，能实现吗
    //         })

    //     }
    //     if (temp.isUpload) {
    //       console.log('上传新附件中')
    //       temp.fileList.forEach((fileObj) => {
    //         let single = files.filter((file) => file.name == fileObj)
    //         console.log('文件', single)
    //         this.upLoad(single[0], temp)
    //       })
    //     }
    //   })
    // },

    async beforeUpLoad(files) {
      console.log('上传前的文件有', files)
      const urlParam = this.getHashQueryParams()
      for (let [index, temp] of this.templateFile.entries()) {
        console.log('遍历表格数据中', temp)
        // 如果需要删除附件
        if (temp.isDelete) {
          console.log('删除原附件中')
          const param = {
            itemId: Number(temp.itemId),
            itemSubClass: Number(temp.itemSubclassId),
            changeId: Number(urlParam.id),
            changeSubClass: Number(urlParam.subClassId),
          }
          console.log('删除请求的参数是', param)
          try {
            const res = await axios.get(
              `/pmdm/changes/deleteAIFile${this.params(param)}`
            )
            console.log('删除结果', res)
            if (res.data.code !== 200) {
              console.warn('删除失败，跳过上传')
              this.$message.error(res.data.message)
              continue
            } else {
              this.$message.success(res.data.message)
            }
            //这里需要判断如果是最后一行，只有删除标记的话，执行完需要刷新当前界面
            if (
              ++index == this.templateFile.length &&
              temp.isDelete &&
              !temp.isUpload
            ) {
              this.$emit('reloadPage')
            }
          } catch (error) {
            console.error('删除失败：', error)
            this.$message.error('删除失败')
            continue // 删除失败不上传，继续下一个 temp
          }
        }

        // 如果需要上传附件
        if (temp.isUpload) {
          console.log('上传新附件中')
          for (const fileObj of temp.fileList) {
            const single = files.find((file) => file.name === fileObj)
            if (single) {
              await this.upLoad(single, temp) // 如果 upLoad 是异步函数
            }
          }
        }
      }
    },

    async upLoad(file, itemdata) {
      console.log('上传参数', itemdata)
      console.log('组件内参数', this.templateFile)

      const fd = new FormData()
      const param = this.getHashQueryParams()

      // 获取指定参数
      const changeId = param.id
      const changeClassId = param.classId
      const changeSubClassId = param.subClassId
      const classId = itemdata.itemClassId
      const subClassId = itemdata.itemSubclassId
      const id = itemdata.itemId

      // const objInfo = {
      //   ...this.$store.state.objectId,
      // ...this.changeInfo,
      // }
      // const { classId, subClassId, id } = objInfo,
      const tenantName = window.sessionStorage.getItem('tenantName')
      console.log('tenantName', tenantName)

      const path = [
        tenantName,
        classId,
        subClassId,
        id,
        changeId,
        file.name,
      ].join('/')

      const obj = {
        id,
        classId,
        subClassId,
        path,
        changeId,
        changeClassId,
        changeSubClassId,
        fileSize: file.size,
        fileName: file.name,
      }
      console.log('obj', obj)

      for (const key in obj) {
        fd.append(key, obj[key])
      }
      fd.forEach((value, key) => {
        console.log(`${key}:`, value)
      })
      await axios
        .post('/swift-file/files/checkFileNameAndRev', fd)
        .then((res) => {
          console.log('上传返回值是', res)
          const { code, url, message, fileName } = res.data.object
          if (code == 501) {
            this.$confirm(
              this.$t('message.confirm.overwrite'),
              fileName,
              this.$t('message.tips.tip'),
              {
                confirmButtonText: this.$t('message.button.affirm'),
                cancelButtonText: this.$t('message.button.cancel'),
                type: 'warning',
              }
            )
              .then(() => {
                this.updateFile(file, fd, url)
              })
              .catch(() => {
                this.$message({
                  type: 'info',
                  message: this.$t('message.tips.cancel'),
                })
              })
          } else if (code == 200) {
            this.updateFile(file, fd, url)
            return true
          } else {
            this.$message.error(message)
            return false
          }
        })
    },

    async updateFile(file, fd, url) {
      var reopt = {
        method: 'PUT',
        url: url,
        withCredentials: false,
        headers: { 'Content-Type': 'application/octet-stream' },
        validateStatus: function (status) {
          return status >= 200
        },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.lengthComputable) {
            var complete =
              ((progressEvent.loaded / progressEvent.total) * 100) | 0
            for (let index = 0; index < 81; index++) {
              this.upLoadProgress = index
            }
            if (complete >= 100) {
              this.upLoadDialog = false
              this.upLoadProgress = 0 // 重新置0
            }
          }
        },
        maxRedirects: 0,
        data: file,
      }
      await axios
        .request(reopt)
        .then((res) => {
          if ((res.status = 200 && res.data == '')) {
            return axios.post('/swift-file/files/uploadFileMetadata', fd)
          }
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message:
                this.$t('message.title.attachment') +
                file.name +
                this.$t('message.success.upLoad'),
              type: 'success',
            })
            this.templateFile.forEach((item) => {
              item.fileList.forEach((name) => {
                if (name === file.name) {
                  if (item.complete) {
                    item.complete.push(file.name)
                  } else {
                    let complete = []
                    item.complete = complete
                    item.complete.push(file.name)
                  }
                  if (item.complete.length == item.fileList.length) {
                    //说明全部上传完成
                    item.completeFlag = true
                  }
                }
              })
            })
            const fileCompleted = this.templateFile
              .filter((item) => item.fileList.length != 0)
              .every((i) => !!i?.completeFlag)
            console.log('刷新吗？', { tf: this.templateFile, fileCompleted })
            fileCompleted && this.$emit('reloadPage')
            // fileCompleted && location.reload()
          }
        })
        .catch(function (err) {
          console.log('123456', err)
          this.$message.error(this.$t('message.error.add'))
        })
    },

    getChangeInfo() {
      console.log('init', this.changeInfo)
    },
  },
}
</script>

<style scoped>
.del {
  margin-left: 6px;
  cursor: pointer;

  &:hover {
    color: #4b92ff;
  }
}

.dovDropzone {
  /* background: silver; */
  width: 100%;
  height: 260px;
  border: #4b92ff 1px dashed;
  margin: 8px 0;
  font-size: 12px;
  padding: 10px 15px;
  box-sizing: border-box;
  overflow: auto;
}

.dropzone .filehover {
  background-color: cadetblue;
}

/* .searchAddBomList .el-dialog__body {
  padding: 0 20px 20px 20px !important;
} */

.el-dialog__body {
  padding: 0px 20px !important;
}

.el-table th.gutter {
  display: table-cell !important;
}

.link_ {
  color: #4b92ff;
  cursor: pointer;
}

.link_:hover {
  color: #4b92ff;
  cursor: pointer;
  border-bottom: 1px solid #4b92ff;
}

.up-button {
  /* width: 120px; */
  /* height: 32px;
  line-height: 32px; */
  color: #fff;
  font-size: 12px;
  background-color: #4b92ff;
  padding: 6px 12px;
  cursor: pointer;
  border-radius: 3px;
}

.btn-left {
  /* border-radius: 3px 0 0 3px; */
}

.btn-right {
  /* border-radius: 0 3px 3px 0; */
  margin-left: 10px;
}

.up-file {
  border: none;
  display: none;
}

.input-file {
  display: none;
}

.drag-upload-box {
  /* width: 200px;
  height: 130px; */
  width: 100%;
  height: 600px;
}

.available {
  position: relative;
  /* 必须设置相对定位 */
}

.drag-upload-box.available::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(64, 158, 255, 0.3);
  /* rgba(87, 98, 227, 0.5); */
  /* 设置蒙版颜色和透明度 */
  z-index: 1;
  /* 确保蒙版在元素上方 */
}

.fileNameTag {
  margin: 0px 5px;
}

.drag-upload-box.available>* {
  /* 防止拖拽到 子元素导致触发 dragleave*/
  pointer-events: none;
}

.drag-upload-box.guide>* {
  pointer-events: none;
}

.table-area {
  margin: 20px auto;
  min-height: 350px;
  max-height: 400px;
  overflow: auto;
  text-align: center;
  box-sizing: border-box;
}
</style>
